var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../styles/EndSessionPage.css';
import HomeHeader from './common/HomeHeader';
import Footer from './common/Footer';
import usineLoader from '../imgs/usineLoader.png';
import { useLanguage } from './context/LanguageContext';
import { useAppState } from './context/AppStateContext';
import { SceneStates } from "../datas/constants";
var EndSessionPage = function () {
    var searchParams = useSearchParams()[0];
    var type = searchParams.get('type');
    var langParam = searchParams.get('lang') || 'fr';
    var navigate = useNavigate();
    var _a = useLanguage(), language = _a.language, setLanguage = _a.setLanguage;
    var _b = useAppState(), sceneState = _b.sceneState, setSceneState = _b.setSceneState;
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    setSceneState(SceneStates.END_SESSION);
    useEffect(function () {
        setLanguage(langParam);
        switch (type) {
            case 'reload':
                setMessage(langParam === 'fr'
                    ? "Hmmm, impossible de se connecter, merci de relancer la visite ultérieurement. Si le problème persiste nous nous excusons du désagrément."
                    : "Connection failed. Please try again later.");
                break;
            case 'changeNavigator':
                setMessage(langParam === 'fr'
                    ? "Hmmm, impossible de se connecter, essayez avec un navigateur Chrome ou Firefox mis à jour récemment."
                    : "Please try again using Chrome or Firefox (latest version).");
                break;
            case 'endSession':
                setMessage(langParam === 'fr'
                    ? "Votre session s'est terminée mais vous pouvez revenir quand vous voulez et même dès maintenant. L'usine virtuelle est ouverte 7 jours sur 7, 24h sur 24h."
                    : "Your session has ended, but you can come back anytime. The virtual factory is open 24/7.");
                break;
            default:
                setMessage(langParam === 'fr'
                    ? "Hmmm, impossible de se connecter, merci de relancer la visite ultérieurement."
                    : "Unable to connect, please try again later.");
        }
    }, [type, langParam, setLanguage]);
    var handleReplay = function () {
        navigate('/');
    };
    var handleHome = function () {
        var domain = window.location.hostname;
        var url = '#';
        switch (domain) {
            case 'produitsvirtuels.sferaco.com':
            case 'www.produitsvirtuels.sferaco.com':
                url = 'https://www.sferaco.com/fr/usine-virtuelle';
                break;
            case 'produitsvirtuels.sectoriel.com':
            case 'www.produitsvirtuels.sectoriel.com':
                url = 'https://www.sectoriel.com/fr/';
                break;
            case 'produitsvirtuels.syveco.com':
            case 'www.produitsvirtuels.syveco.com':
                url = 'https://www.syveco.com/en/';
                break;
        }
        window.location.assign(url);
    };
    return (_jsxs("div", __assign({ className: "end-session-wrapper", style: {
            backgroundImage: "url(".concat(usineLoader, ")"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        } }, { children: [_jsx(HomeHeader, { setHeaderHeight: function () { }, subsidiary: "sferaco" }), _jsxs("div", __assign({ className: "end-session-page" }, { children: [_jsx("div", { id: "bluredBackground" }), _jsxs("div", __assign({ id: "end-session-content" }, { children: [_jsx("p", __assign({ id: "end-session-text" }, { children: message })), _jsxs("div", __assign({ className: "end-session-buttons" }, { children: [type !== 'changeNavigator' && (_jsx("button", __assign({ className: "btn loader-end-session-button", onClick: handleReplay }, { children: langParam === 'fr' ? 'Relancer' : 'Restart' }))), _jsx("button", __assign({ className: "btn loader-end-session-button", onClick: handleHome }, { children: langParam === 'fr' ? 'Accueil' : 'Home' }))] }))] }))] })), _jsx(Footer, {})] })));
};
export default EndSessionPage;
